import { pxToEm } from '@insticator/insticator-ui';

export default {
    expandableSection : {
        display: 'flex',
        flexDirection: 'column',
        gap: pxToEm(16),
        marginTop: pxToEm(16),
            '& > .content': {
                display: 'flex',
                flexDirection: 'column',
                gap: pxToEm(16),
                paddingLeft: pxToEm(24),
                borderLeft: ' 2px solid #AEB6D6',
            },
        '& > .section':{
            '& > .button':{
                width: 'auto',
                padding: '0 1em'
            },
        }
    }
}